<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        Log Detail
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">Log</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">mail</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Log
            </div>
            <div class="mb7">
              Date : {{model.created_at | datetime}}
            </div>
          </div>
          <hr>
          <div class="mb-2">
            <div class="row mb-2">
              <div class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_sent_at" v-b-tooltip.hover>sent_at</label>
              </div>
              <div class="col-xl-4 col-md-12  d-flex align-self-center">
                <label class="mt-2" for="ph_sent_at" v-b-tooltip.hover>{{model.sent_at | datetime}}</label>
              </div>
              <div class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_result" v-b-tooltip.hover>Result</label>
              </div>
              <div class="col-xl-4 col-md-12">
                <span class="badge badge-success mt-2" :variant="model.is_success ? 'success' : 'danger'">{{model.is_success ? 'success' : 'failed'}}</span>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_email_to" v-b-tooltip.hover>To</label>
              </div>
              <div class="col-xl-4 col-md-12  d-flex align-self-center">
                <label v-if="show" class="mt-3" for="ph_email_to" v-b-tooltip.hover>
                  <pre for="ph_email_to" v-b-tooltip.hover>{{model.email_to || "-"}}</pre>
                </label>
                <label v-else class="mt-3" for="ph_email_to" v-b-tooltip.hover>
                  <pre v-if="model.email_to" for="ph_email_to" v-b-tooltip.hover>{{model.email_to | truncate(21)}}</pre>
                  <pre v-else for="ph_email_to" v-b-tooltip.hover>-</pre>
                </label>
              </div>
              <div class="col-xl-2 col-md-12 d-flex align-self-center">
                <label v-if="show" class="col-form-label" for="ph_username" v-b-tooltip.hover>BCC</label>
                <label v-else class="col-form-label" for="ph_type" v-b-tooltip.hover>Type(template)</label>
              </div>
              <div class="col-xl-4 col-md-12">
                <label v-if="show" class="mt-3" for="ph_email_to" v-b-tooltip.hover>
                  <pre for="ph_username" v-b-tooltip.hover>{{model.email_bcc || "-"}}</pre>
                </label>
                <label v-else class="mt-4" for="ph_type" v-b-tooltip.hover>
                  <pre for="ph_type" v-b-tooltip.hover>{{model.type}}</pre>
                </label>
              </div>
            </div>
            <div v-if="show" class="row mb-2">
              <div class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_username" v-b-tooltip.hover>CC</label>
              </div>
              <div class="col-xl-4 col-md-12  d-flex align-self-center">
                <label class="mt-3" for="ph_username" v-b-tooltip.hover>
                  <pre for="ph_username" v-b-tooltip.hover>{{model.email_cc || "-"}}</pre>
                </label>
              </div>
              <div class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_type" v-b-tooltip.hover>Type(template)</label>
              </div>
              <div class="col-xl-4 col-md-12">
                <label class="mt-4" for="ph_type" v-b-tooltip.hover>
                  <pre for="ph_type" v-b-tooltip.hover>{{model.type}}</pre>
                </label>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-xl-12 col-md-12 align-self-center text-center">
                <label class="col-form-label" style="cursor: pointer;" v-b-tooltip.hover @click="change_name">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </label>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title" v-b-tooltip.hover>Title</label>
            </div>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_title" v-b-tooltip.hover>{{model.title}}</label>
            </div>
          </div>
          <b-row v-if="model.preview">
            <b-col>
              <label class="col-form-label" for="ph_contents" v-b-tooltip.hover>Preview</label><br>
              <samp v-html="model.preview" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px; min-height: 1000px;" class="w-100 d-inline-block">
              </samp>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12">
              <b-form-group>
                <b><label class="col-form-label" for="ph_contents" v-b-tooltip.hover>Content Data</label><br></b>
                <pre for="ph_contents" v-b-tooltip.hover>{{model.content}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right mt-3" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>